export const formatDate = (value?: string) => {
  if (value) {
    return value.split('-').reverse().join('.')
  }

  return new Date().toISOString().split('T')[0].split('-').reverse().join('.')
}
